import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Base styles to match Input/Select
          "flex min-h-[120px] w-full rounded-lg border border-sds-neutral-20 bg-white px-4 py-3 text-base md:text-sm placeholder:text-muted-foreground",
          // Focus state: purple border, no glow
          "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-sds-purple-100",
          // Hover/disabled
          "hover:border-sds-neutral-40 disabled:cursor-not-allowed disabled:bg-sds-neutral-00 disabled:text-sds-neutral-60",
          // Invalid state via aria-invalid
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:text-destructive",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
